import api from "./axiosConfig";
import { HERO_ENDPOINT } from "./apiEndpoints";
import { getItem } from "../utils/localStorageUtil";
import { logError } from './errorLogService';

const isZho = getItem('lang') == 'zho'

const defaultHeroData = {
  main_title_text: isZho ? '我们是一家具备完整产业链的全球领先的作物保护公司' : "We're a fully integrated crop protection company",
  main_title_text_zho: "We're a fully integrated crop protection company",
  subtitle_text: isZho ? '润泽万物 丰登五谷' : 'All about growing',
  subtitle_text_zho: "All about growing",
  button_text: isZho ? '联系我们' : 'Get in touch',
  button_text_zho: "Get in touch",
  background_src: '',
  background_type: 'video',
  video_fallback_image: '/assets/videos/fallback-image.png',
  video_desktop: '/assets/videos/Rainbow_header_1920x1080.mp4',
  video_mobile_landscape: '/assets/videos/Rainbow_header_1280x720.mp4',
  video_mobile_portrait: '/assets/videos/Rainbow_header_720x1280.mp4'
};

export const fetchHero = async () => {
  // if (isMockEnabled) {
  //   return mockHeroData; // Usa datos mock si está activado
  // }

  try {
    const response = await api.get(HERO_ENDPOINT());
    return response.data;
  } catch (error) {
    console.error("Error fetching hero data, fetching default hero", error);

    await logError('hero_data_fetch', error, {
      endpoint: HERO_ENDPOINT(),
      response_status: error.response?.status,
      response_data: error.response?.data,
    });

    return defaultHeroData;
  }
};

